import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useWaiterAuth } from '../context/WaiterAuthContext';

const WaiterSidebar = ({ currentWaiter }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useWaiterAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect if mobile view
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const menuItems = [
    { path: '/waiter/dashboard', label: 'Dashboard', icon: '🏠', shortLabel: 'Home' },
    { path: '/waiter/order-line', label: 'Order Line', icon: '📋', shortLabel: 'Orders' },
    { path: '/waiter/tables', label: 'Tables', icon: '🪑', shortLabel: 'Tables' },
    { path: '/waiter/report', label: 'Reports', icon: '📊', shortLabel: 'Reports' },
    { path: '/waiter/terminals', label: 'Settings', icon: '⚙️', shortLabel: 'Settings' }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    if (isMobile) {
      setIsMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Desktop Sidebar
  if (!isMobile) {
    return (
      <div className="waiter-sidebar">
        <div className="sidebar-header">
          <h2>🍽️ Tasty Station</h2>
          <p>Waiter Panel</p>
        </div>

        <nav className="sidebar-menu">
          {menuItems.map(item => (
            <button
              key={item.path}
              className={location.pathname === item.path ? 'active' : ''}
              onClick={() => navigate(item.path)}
            >
              <span className="icon">{item.icon}</span>
              <span className="label">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <span>{currentWaiter?.name || 'Waiter'}</span>
            <span className="role">Waiter</span>
          </div>
          <button onClick={logout} className="logout-btn">
            🚪 Logout
          </button>
        </div>
      </div>
    );
  }

  // Mobile Bottom Navigation
  return (
    <>
      {/* Mobile Hamburger Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="waiter-mobile-overlay" onClick={toggleMobileMenu}>
          <div className="waiter-mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <h2>🍽️ Menu</h2>
              <button className="close-mobile-menu" onClick={toggleMobileMenu}>
                ✕
              </button>
            </div>
            <div className="mobile-menu-content">
              <div className="user-info-mobile">
                <div className="user-avatar">
                  {(currentWaiter?.name || 'W').charAt(0).toUpperCase()}
                </div>
                <div>
                  <div className="user-name">{currentWaiter?.name || 'Waiter'}</div>
                  <div className="user-role">Waiter</div>
                </div>
              </div>
              <nav className="mobile-menu-items">
                {[
                  ...menuItems,
                  { path: '/waiter/master-pos', label: 'Master POS', icon: '👑', shortLabel: 'Master' }
                ].map(item => (
                  <button
                    key={item.path}
                    className={location.pathname === item.path ? 'active' : ''}
                    onClick={() => handleNavigation(item.path)}
                  >
                    <span className="icon">{item.icon}</span>
                    <span className="label">{item.label}</span>
                  </button>
                ))}
              </nav>
              <button onClick={logout} className="logout-btn-mobile">
                🚪 Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Bottom Navigation Bar */}
      <nav className="waiter-bottom-nav">
        {menuItems.map(item => (
          <button
            key={item.path}
            className={location.pathname === item.path ? 'active' : ''}
            onClick={() => handleNavigation(item.path)}
          >
            <span className="icon">{item.icon}</span>
            <span className="label">{item.shortLabel}</span>
          </button>
        ))}
      </nav>

      {/* Mobile Header with Hamburger */}
      <div className="waiter-mobile-header">
        <button className="hamburger-btn" onClick={toggleMobileMenu}>
          ☰
        </button>
        <h1>🍽️ Tasty Station</h1>
        <div className="header-spacer"></div>
      </div>
    </>
  );
};

export default WaiterSidebar;
